import {lazy} from 'react';
import {createRoute, type AnyRoute} from '@tanstack/react-router';

import {requireSessionWithLoginPrompt} from 'lib/decorators/requireSession';
import {redirectRoute} from 'client/routeHelpers';

const Marketplace = lazy(() => import('./Marketplace.react'));
const CheckoutConfirmation = lazy(() => import('./Checkout/Confirmation/Confirmation.react'));

/**
 * `/marketplace` → redirects to `/marketplace/subjects`; both leaf pages require
 * a session (login prompt). Mirrors the RR3 IndexRedirect + two routes.
 */
export function makeMarketplaceRoute(parentRoute: AnyRoute): AnyRoute {
  const marketplaceRoute = createRoute({getParentRoute: () => parentRoute, path: 'marketplace'});
  const indexRedirect = redirectRoute({
    getParentRoute: () => marketplaceRoute,
    path: '/',
    to: '/marketplace/subjects'
  });
  const subjectsRoute = createRoute({
    getParentRoute: () => marketplaceRoute,
    path: 'subjects',
    component: requireSessionWithLoginPrompt()(Marketplace)
  });
  const confirmationRoute = createRoute({
    getParentRoute: () => marketplaceRoute,
    path: 'confirmation',
    component: requireSessionWithLoginPrompt()(CheckoutConfirmation)
  });
  return marketplaceRoute.addChildren([indexRedirect, subjectsRoute, confirmationRoute]);
}
